export default __webpack_public_path__ + "static/media/kanban1.82f85928.png";